import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "cf-cookie-consent";

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) {
            const t = setTimeout(() => setVisible(true), 1200);
            return () => clearTimeout(t);
        }
    }, []);

    const choose = (value) => {
        localStorage.setItem(KEY, value);
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    data-testid="cookie-banner"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 40 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] rounded-2xl border border-white/15 bg-[#0A0A0A]/95 backdrop-blur-xl p-6 shadow-2xl"
                >
                    <div className="flex items-start gap-4">
                        <span className="w-10 h-10 rounded-xl bg-[#FF6B00] flex items-center justify-center shrink-0">
                            <Cookie className="w-5 h-5 text-white" />
                        </span>
                        <div>
                            <p className="font-heading text-white font-bold tracking-tight text-lg">
                                Cookies op {window.location.pathname.startsWith("/club-fin") ? "Club-Fin.nl" : "MeerjarenplanOnline.nl"}
                            </p>
                            <p className="mt-1 text-white/60 text-sm leading-relaxed">
                                Wij gebruiken noodzakelijke cookies om de site te laten werken en —
                                alleen met jouw toestemming — analytische cookies om de site te
                                verbeteren. Lees onze{" "}
                                <a href="/privacy" data-testid="cookie-banner-privacy-link" className="text-[#FF8A3D] underline underline-offset-2">
                                    privacyverklaring
                                </a>
                                .
                            </p>
                        </div>
                    </div>
                    <div className="mt-5 flex flex-col sm:flex-row gap-3">
                        <button
                            data-testid="cookie-accept-button"
                            onClick={() => choose("all")}
                            className="flex-1 rounded-full bg-[#FF6B00] hover:bg-[#e05e00] text-white text-sm font-bold px-5 py-3 transition-[background-color,transform] duration-300 hover:scale-[1.02]"
                        >
                            Alles accepteren
                        </button>
                        <button
                            data-testid="cookie-decline-button"
                            onClick={() => choose("necessary")}
                            className="flex-1 rounded-full border border-white/25 hover:border-white/60 text-white text-sm font-bold px-5 py-3 transition-[border-color] duration-300"
                        >
                            Alleen noodzakelijk
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
